app.service('cartManager', function ($global, console, cartBox, loading, modal, front, log) {

	function removeProduct(option, success) {
		loading.start();
		$.ajax({
			url: '/remove-product-from-cart.ltr',
			method: 'POST',
			cache: false,
			data: option,
			success: function () {
				loading.stop();
				console.log('USUNIETO Z KOSZYKA: ' + option.productId);
				cartBox.refresh();
				if ($.isFunction(success)) {
					success();
				}
			}, error: function () {
				loading.stop();
				console.log('USUNIETO Z KOSZYKA - ERROR');
			}
		});
	}
	function simpleAddProduct(option, success, error) {
		var data = {
			addedFrom: '',
			toCart: false
		};
		$.extend(true, data, option);
		loading.start();
		$.ajax({
			url: '/add-product-to-cart.ltr',
			method: 'POST',
			cache: false,
			data: data,
			success: function (json) {
				loading.stop();
				if (json.status == 'SUCCESS') {
					console.log('DOODANO DO KOSZYKA: ' + data.productId);
					cartBox.refresh();
					if ($.isFunction(success)) {
						success();
					}
				} else {
					modal.alert(json.reason);

					if ($.isFunction(error)) {
						error(json);
					}
					cartBox.refresh();
				}
			}, error: function () {
				loading.stop();
				console.log('DOODANO DO KOSZYKA - ERROR');
			}
		});
	}

	$global('simpleAddProduct', simpleAddProduct);

	return {
		simpleAddProduct,
		removeProduct
	};
});
